import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { Project } from '../types/project';
import customFetch from '../utils/fetch';
export const useGetProjects = (pageNumber: number, pageSize = 100) => {
  const {
    data,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['getProjects', pageNumber, pageSize],
    queryFn: async () => {
      const response = await customFetch(`${BASE_API_URL}/projects?pageNumber=${pageNumber}&pageSize=${pageSize}`, {});
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch projects');
      }
      const {
        data,
        page,
        totalPages
      } = (await response.json() as {
        data: Project[];
        page: number;
        totalPages: number;
      });
      return {
        projects: data,
        totalPages,
        page
      };
    },
    retry: false
  });
  return {
    data,
    isLoading,
    isError,
    error
  };
};